import Flag from '../Flag';

/** Crosshair flag */
export default class CrosshairFlagY extends Flag {
	_getStyle(args = {}) {
		const returnStyle = this.panel.core.getStyle('flag.crosshair.yAxis');
		const panelStyle = this.panel.params.style;

		// Use fallback values if necessary
		if (!returnStyle.font.family) returnStyle.font.family = panelStyle.yAxis.font.family;
		if (!returnStyle.font.size) returnStyle.font.size = panelStyle.yAxis.font.size;

		return {
			...returnStyle,
			...args.style
		};
	}

	/**
	 * @returns The appropriate event emitter types
	 * @type {object}
	 */
	get eventType() {
		return {
			render: 'FLAG_RENDER_CROSSHAIR',
			hide: 'FLAG_HIDE_CROSSHAIR',
			show: 'FLAG_SHOW_CROSSHAIR'
		};
	}
}
